import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import UrlFetcherFetch from '../../fetch/urlFetcherFetch';

import { useParams } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import profileFetch from "../../fetch/profileFetch";


function EditorUrlFetcher() {

    const [value, setValue] = useState("");
    const [message, setMessage] = useState("");
    const [link, setLink] = useState("");
    const [companyOptions, setCompanyOptions] = useState([]);
    const [company, setCompany] = useState({});
    const [mode, setMode] = useState("investor");


    const {requestId} = useParams();

    const handleModeChange = (event) => {
        setMode(event.target.value);
    };


    const sendRequest = () => {
        UrlFetcherFetch.getUrl(requestId, value, company.idCbiEntity, mode).then(response => {
            setMessage("The link is ");
            setLink(response.url);
        }).catch(err => {
            setMessage("Error fetching. Please request a new link at ")
            setLink("https://editor.data-cbinsights.com/url_fetcher");
        });
    }

    const searchCompany = (searchTerm) => {
        profileFetch.searchEntity(searchTerm, 3).then(response=> {
            setCompanyOptions(response);
        });
    }

    useEffect(() => {
        if (typeof(Storage) !== "undefined" && localStorage !== null) {
            var value = localStorage.getItem("value");

            if (value === null) {
                value = crypto.randomUUID()
                localStorage.setItem("value", value);
            }
            setValue(value);
        }
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid size={10} offset={1}>
                <Paper>
                    <div style={{marginTop: "16px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                        <FormControl sx={{color: "#777", marginTop: "96px"}}>
                            <RadioGroup
                                defaultValue="investor"
                                row
                            >
                                <FormControlLabel value="investor" control={
                                    <Radio value="investor" onChange={handleModeChange} />
                                } label="Investor" />
                                <FormControlLabel value="company" control={
                                    <Radio value="company" onChange={handleModeChange} />
                                } label="Company" />
                            </RadioGroup>
                        </FormControl>
                        <Typography
                            sx={{color: "#777"}}
                            variant={'subtitle1'}
                        >
                            Search for the company below to get the Editor link.
                        </Typography>
                        <Autocomplete
                            disablePortal
                            options={companyOptions}
                            getOptionLabel={(option) => option.name === undefined ? "" : option.name + " (" + option.url + ")"}
                            sx={{ width: 400, marginTop: "16px" }}
                            onInputChange={(event, value) => searchCompany(value) }
                            value={company}
                            onChange={(event, value) => setCompany(value)}
                            renderInput={(params) => <TextField {...params} label="Company" />}
                        />
                        <Button variant="contained"
                                sx={{marginTop: "28px"}}
                                onClick={sendRequest}
                                disabled={ !company || !company.idCbiEntity}
                        >
                            Fetch
                        </Button>
                        <Typography
                            sx={{color: "#555", marginTop: "16px"}}
                            variant={'subtitle1'}
                        >
                            {message}
                        </Typography>
                        <Typography
                            sx={{color: "#555", marginTop: "16px", marginBottom: "48px"}}
                            variant={'subtitle1'}
                        >
                            <a href={link} target="_blank" rel="noreferrer">{link}</a>
                        </Typography>
                    </div>
                </Paper>
            </Grid>
        </Grid>
    )
}

export default EditorUrlFetcher;